'use client'

import { ChevronRight } from 'lucide-react'
import Image from 'next/image'
import { HomeLink } from '@/components/home-link'
import { Button } from '@/components/ui/button'
import medalIcon from '@/public/icons/medal-2.svg'
import monitorIcon from '@/public/icons/monitor.svg'
import wavyLineImg from '@/public/img/wavy-line.svg'

export function HeroBf() {
  return (
    <div className="flex flex-wrap items-center justify-evenly">
      <div className="mx-auto w-full lg:max-w-160 xl:mx-0 xl:max-w-md">
        <div className="max max-w-108 space-y-2">
          <picture>
            <source
              media="(min-width: 768px)"
              srcSet="/img/info-buttons-desktop.png"
            />
            <Image
              alt=""
              className="mx-auto md:mx-0"
              height={72.82}
              src="/img/info-buttons-mobile.png"
              width={384}
            />
          </picture>
          <h1 className="font-bold text-4.5xl text-primary-800 leading-none">
            Evolua na Maior escola de educadores da América Latina.
          </h1>
          <Image
            alt=""
            className="ml-28 w-[12.928125rem] sm:ml-auto sm:w-86.5 md:ml-0 lg:w-86.5"
            src={wavyLineImg}
            unoptimized
          />
        </div>
        <div className="mt-4">
          <p className="font-medium text-gray-500 text-sm md:text-lg md:leading-7">
            Aprimore suas habilidades e mantenha-se atualizado com as práticas
            educacionais mais recentes.
          </p>
          <div className="mt-4 flex items-center gap-4 sm:max-w-80">
            <Button
              asChild
              className="min-h-10 max-w-53 bg-green-700 text-white"
              size="lg"
            >
              <HomeLink className="font-semibold text-sm" href={'/conta/novo'}>
                Comece Grátis
              </HomeLink>
            </Button>

            <Button asChild className="w-1/2" id="courses-button" size="lg">
              <HomeLink
                className="flex items-center justify-between font-bold"
                href={'/cursos'}
              >
                Todos os cursos
                <ChevronRight strokeWidth={3} />
              </HomeLink>
            </Button>

            {/* <Image
            src={threeDashesImg}
            alt=""
            className="h-9.25 w-25.5 sm:h-12 sm:w-44.25 md:h-12 md:w-44.25"
          /> */}
          </div>
        </div>
      </div>

      <div className="relative mx-auto mt-17 xl:m-0">
        <div className="w-full">
          <picture>
            <source
              media="(min-width: 768px)"
              srcSet="/img/home-natalina-desktop.png"
            />
            <Image
              alt="Homem usando um notebook"
              height={467.98}
              quality="65"
              src="/img/home-natalina-mobile.png"
              width={500}
            />
          </picture>
          {/* <Image
          src={risksImg}
          alt=""
          loading='lazy'
          width={156.75}
          height={128.32}
          className="absolute -left-5 -top-14 md:-left-25 md:-top-6"
        /> */}
        </div>
      </div>
    </div>
  )
}
